import { map } from 'rxjs/operators'
import { afterAllTypes } from '../../../../lib/observables'
import { SET_ROOMNAME, SET_USER, SET_ROLE } from '../../../constants/actionTypes'
import setupActions from '../../../actions/setup'

const triggerFetch$ = (actions$) => actions$.pipe(
  afterAllTypes(SET_USER, SET_ROOMNAME, SET_ROLE),
  map(() => setupActions.fetchToken())
)

export default triggerFetch$
